import React from 'react'
import ProjectCompo from '../../component/DummyProCompo/ProjectCompo'

function DummyPro() {
  return (
    <main className='case-study project-page'>
      <div className="ml-72">
        <div className="case-main proj-main pt-48">
          <div className="proj-box">
            <ProjectCompo /></div>
          <div className="case-left">
            <h3 className="title">
              Dummy Projects
            </h3>
            <p className="detail-para proj-para">These dummy projects illustrate my journey and growth as a UI Develper, where I have combined self-taught knowledge from YouTube tutorials with practical experience. Each project showcases modern design trends, responsiveness, and user-friendly interfaces. By experimenting with various design techniques and tools, I have developed a robust understanding of UI development. These projects serve as a testament to my creativity, dedication, and commitment to continuous improvement in the field of UI development.</p>
          </div>
          

          </div>
        </div>
    </main>
  )
}

export default DummyPro